
import FbxButton from './fbx-button.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        titleText: String,
        subtitleText: String,
        acceptText: {
            type: String,
            default: 'Accept',
        },
        rejectText: {
            type: String,
            default: 'Reject',
        },
        acceptTheme: {
            type: String,
            default: 'primary',
        },
        rejectTheme: {
            type: String,
            default: 'return',
        },
        confirmationLoading: {
            type: Boolean,
            default: false,
        },
        rejectionLoading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        FbxButton,
    },
    methods: {
        acceptClicked(): void {
            this.$emit('accept', { didAccept: true });
        },
        rejectClicked(): void {
            this.$emit('reject', { didAccept: false });
        },
    },
});
